import {TextModel} from "models/Text"
import {connect} from "react-redux"
import {applyAllFacets} from "../../ducks/search"
import {setViewAllCloseAction} from "../../ducks/viewAllModal"
import State from "../../models/State"

type StateProps = {
    isViewMoreOpen: boolean
    title: string
    hideSearchBox: boolean
    hideLetterNav: boolean
    text: TextModel
}
export const mapStateToProps = (state: State) => {
    const isViewMoreOpen = state.viewAllModal.isOpen
    const title = state.viewAllModal.displayName
    const hideSearchBox = state.viewAllModal.hideSearchFilterModalElements.searchBox
    const hideLetterNav = state.viewAllModal.hideSearchFilterModalElements.letterNav
    const {text} = state

    return {
        isViewMoreOpen,
        title,
        hideSearchBox,
        hideLetterNav,
        text,
    } as StateProps
}

export const mapDispatchToProps = (dispatch: any) => ({
    onClose: (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        dispatch(setViewAllCloseAction())
    },

    onCloseResize: () => {
        dispatch(setViewAllCloseAction())
    },

    onCloseApplyFilter: () => {
        dispatch(applyAllFacets())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
